import { Box, Tab, Tabs } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Fragment, useContext } from 'react'
import VisitadosTab from './VisitadosTab/VisitadosTab'
import VisitantesTab from './VisitantesTab/VisitantesTab'
import SaidasTab from './SaidasTab/SaidasTab'
import EntregasTab from './EntregasTab/EntregasTab'
import { VisitantesContext } from '../../Providers/VisitantesContext/VisitantesContext'
import { EncomendaContex } from '../../Providers/EncomendaContext/EncomendaContext'

const VisitantesPage = () => {
    // const [tabIndex, setTabIndex] = useState(0)
    const { tabIndex, setTabIndex, liberarMorador } = useContext(VisitantesContext)
    const { procurarEncomenda } = useContext(EncomendaContex)

    const tabsOptions = [
        {
            label: "VISITADO(S)",
            componente: VisitadosTab,
            props: {}
        },
        {
            label: "VISITANTE(S)",
            componente: VisitantesTab,
            props: {}
        },
        {
            label: "QUEM ESTÁ DENTRO",
            componente: SaidasTab,
            props: {}
        },
        {
            label: "ENTREGAS",
            componente: EntregasTab,
            props: { ativoNavBar: false }
        }
    ]

    const handleTabChange = (event, newTabIndex) => {
        if (newTabIndex !== 1 || !liberarMorador) {
            setTabIndex(newTabIndex)

            if (newTabIndex === 3) {
                procurarEncomenda()
            }
        }
    }
    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        flexGrow: 0,
                        flexBasis: 'auto',
                        padding: 0,
                        margin: 0,
                        height: '28px',
                        width: '100%',
                        minHeight: '25px',
                        color: "#fff",
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                            padding: 1,
                            margin: 0,
                            minHeight: '28px',
                            height: '28px',
                            width: '250px',
                            color: "#fff !important",
                            borderBottom: '1px solid #fff',
                            fontSize: '0.8vmax',
                            fontWeight: 700,
                            flexShrink: 0,
                            sx: {
                                border: '1px solid white',
                                borderRadius: '5px'
                            }
                        },
                        '& .Mui-selected': {
                            color: "black !important",
                            borderLeft: 'white solid 2px',
                            borderRight: 'white solid 2px',
                            borderTop: 'white solid 2px',
                            borderBottom: '0px',
                            backgroundColor: '#D9D9D9',
                            borderRadius: '5px 5px 0 0',
                            padding: 1,
                            margin: 0
                        }
                    }}
                >
                    {tabsOptions.map((tab) => {
                        return (
                            <Tab
                                key={tab.label}
                                icon={tab.icon ? <tab.icon/> : ''}
                                iconPosition="start"
                                label={tab.label}
                                sx={{
                                    ...(tab.label === "VISITANTE(S)" && liberarMorador && {
                                        color: 'gray',
                                        opacity: 0.5
                                    })
                                }}
                            />
                        )
                    })}
                </Tabs>
            </Box>
            <Grid container sx={{
                margin: 0,
                padding: 0,
                display: 'flex',
                flexBasis: 'auto',
                flexGrow: 1,
                overflowY: 'hidden',
                borderLeft: 'white solid 2px',
                borderBottom: 'white solid 2px',
                borderRight: 'white solid 2px',
                backgroundColor: '#D9D9D9',
                height: '100%'
            }}>
                {tabsOptions.map((tab, index) => {
                    return (
                        <Fragment key={index}>
                            {tabIndex === index &&
                                <tab.componente {...tab.props} key={tab.label}/>
                            }
                        </Fragment>
                    )
                })}
            </Grid>
        </Grid>
    )
}

export default VisitantesPage
